"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var react_i18next_1 = require("react-i18next");
var notifier_1 = __importDefault(require("@utils/notifier"));
function CopyIcon(_a) {
    var value = _a.value;
    var t = (0, react_i18next_1.useTranslation)().t;
    var handleClick = function () {
        if (navigator.clipboard) {
            try {
                navigator.clipboard.writeText(value).then(function () {
                    notifier_1.default.display(t('ITEM.COPY_MESSAGE_REACT', { value: value }), { type: 'success', duration: 1500 });
                });
            }
            catch (err) {
                notifier_1.default.display(t('ITEM.COPY_MESSAGE_FAILURE'), { type: 'failure', duration: 1500 });
            }
        }
    };
    return (react_1.default.createElement("div", { className: "implioicons-copy-large eva-copy-icon eva-tooltip-container--center", onClick: handleClick },
        react_1.default.createElement("span", { className: "eva-tooltip" }, t('ITEM.COPY_TOOLTIP'))));
}
exports.default = CopyIcon;
